import { render, staticRenderFns } from "./CountriesList.vue?vue&type=template&id=6275499c&scoped=true"
import script from "./CountriesList.vue?vue&type=script&setup=true&lang=ts"
export * from "./CountriesList.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CountriesList.vue?vue&type=style&index=0&id=6275499c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6275499c",
  null
  
)

export default component.exports